<template>
    <div class="">
        <div v-if="em_reg_custom_list.length>0">

            <!-- <div class="card-header px-0 bg-transparent border-0">
                <div class="row no-margin">
                    <div class="col-sm-6 pl-0" >                
                        <div class="employee-btn-holder" style="max-width:210px">
                            <div class="report-intro" style="text-align:center">
                                Bulk Update  
                            </div>  
                            <div  style="min-height:5px;">
                            </div>  
                            <b-button @click="exportUpdateGFSelected" ><b-icon icon="code-slash" ></b-icon> Template</b-button>
                            <b-button :href="this.$api_url+'/gf/import/update'"><b-icon icon="box-arrow-up" class="" scale="1"></b-icon> Import</b-button>                      
                        </div>
                    </div>
                </div>
            </div>   -->

            <common-list  :pageurl="this.$api_url" :is_action="1" :is_pf="is_n_gf" :checkbox="checkbox"  :appended_column="em_reg_appended_column" :key="em_reg_list_key" :company_options="em_reg_company_options" :employees="em_reg_custom_list" :default_column="em_reg_default_column" :primary_key="em_reg_primary_key" v-on:childToParent="reg_edit"></common-list>
        </div>
        <div v-else>
            
            <div v-if="show_loader" class="list-no-data">
                <span class="d-block text-center">Looking for relevant data..</span>
                <img v-bind:src="this.$api_url+'/images/download-loader.svg'" class="loader-logo" width="100px"/>
            </div>
            <div v-else class="list-no-data">
                Looks like there is no GF registrations to show.
            </div>
        </div>




        <b-modal size="md" id="bv-modal-update-gf" hide-footer :title="'Update GF Confirmation Date for '+curr_update_employee">
            <div class="d-block">
                <b-form @submit.stop.prevent="updateEmployeeGF">                    
                    <div class="clearfix">                                         
                        <div class="row clearfix">
                        <div class="col-md-12 float-left">                                         
                          

                            <b-form-group id="gf_approve_date-group"  label="GF Confirmation Date [YYYY-MM-DD]" class="required-field" label-for="gf_approve_date">
                                <b-input-group >        
                                <b-form-input id="gf_approve_date" name="gf_approve_date" v-model="curr_approve_date" v-validate="{required:true,date_format:'yyyy-MM-dd',after:getMinDate(min_date)}"   type="text" placeholder="YYYY-MM-DD" autocomplete="off" :state="validateState('gf_approve_date')" aria-describedby="gf_approve_date-feedback" data-vv-as="GF Confirmation Date"></b-form-input>
                                <b-input-group-append>
                                    <b-form-datepicker id="gf_approve_date" button-only right locale="en-US" v-model="curr_approve_date" :min="min_date"></b-form-datepicker>
                                </b-input-group-append>
                                <b-form-invalid-feedback id="gf_approve_date-feedback">{{ veeErrors.first('gf_approve_date') }}</b-form-invalid-feedback>
                                </b-input-group>
                            </b-form-group>
                        </div> 
                        </div>                           
                    </div>
                
                    <div class="mt-1 ml-4 mb-4 pb-3 clearfix" style="margin-right: 0;">
                        <b-button class="border rounded bg-light float-right py-1 px-5 mt-4 ml-2" type="submit" variant="primary">Submit</b-button>
                    </div>
                </b-form> 
            </div>
        </b-modal>

        <b-modal id="delete-modal" title="Are you sure you want to delete this GF Registration?" hide-footer> 
            <br />
            <div style="height: 10px;clear:both;"> &nbsp;</div>
            <a href="javascript:void(0);" class="btn btn-primary btn-full-width"  @click="deleteGF(curr_update_id)">Delete </a>
            &nbsp;&nbsp; <a href="javascript:void(0);" class="btn btn-primary btn-full-width" block @click="$bvModal.hide('delete-modal')">Cancel</a>
            <div style="height: 5px;clear:both;"> &nbsp;</div>
        </b-modal>

        <b-modal  id="bv-modal-gf-details" hide-footer  title="Employee Profile" size="lg">
            <b-overlay rounded="sm">
                <div v-if="details.length == 0" class="px-3 py-3 no-result-cell text-center">
                    
                    <img v-bind:src="this.$api_url+'/images/download-loader.svg'" class="loader-logo" width="100px"/>
                </div>
                <div  v-else>
                    
                    <div class="clearfix border rounded mt-3  py-2 mb-2 mr-3 mb-0 col-md-12">
                        
                        
                        <div class="row no-margin px-0">
                            <div class="col-md-12">
                                <div class="ibox-content pf-overview px-0 pb-0">
                                    <div class="payslip-details-info-inner row">
                                        <template >
                                            <div class="col-md-6 payslip-details-info-right">
                                                <div class="wrapper">
                                                    <div class="first">Employee Code</div>
                                                    <div class="second"> {{ details.employee_code }} </div>
                                                </div>
                                            </div>
                                            
                                            <div class="col-md-6 payslip-details-info-right">
                                                <div class="wrapper">
                                                    <div class="first">Employee Name</div>
                                                    <div class="second"> {{ details.name }}</div>
                                                </div>
                                            </div>

                                            <div class="col-md-6 payslip-details-info-right">
                                                <div class="wrapper">
                                                    <div class="first">Joining Date</div>
                                                    <div class="second"> {{ details.joining_date }} </div>
                                                </div>
                                            </div>

                                            <!-- <div class="col-md-6 payslip-details-info-right">
                                                <div class="wrapper">
                                                    <div class="first">GF Confirmation Date</div>
                                                    <div class="second"> {{ details.gf_confirmation_date }} </div>
                                                </div>
                                            </div> -->

                                            <div class="col-md-6 payslip-details-info-right">
                                                <div class="wrapper">
                                                    <div class="first">Service Period</div>
                                                    <div class="second"> {{ details.service_period }} </div>
                                                </div>
                                            </div>

                                            <div class="col-md-6 payslip-details-info-right">
                                                <div class="wrapper">
                                                    <div class="first">GF Payable Amount</div>
                                                    <div class="second"> {{ formatMoney(details.payable_amount) }} </div>
                                                </div>
                                            </div>

                                          

                                            <!-- <template v-if="details.gf_end_date != ''">
                                                <div class="col-md-6 payslip-details-info-right">
                                                    <div class="wrapper">
                                                        <div class="first">GF Seperation Date</div>
                                                        <div class="second"> {{ details.gf_end_date }} </div>
                                                    </div>
                                                </div>
                                            </template> -->
                                            <template v-if="details.leaving_date != 'N/A'">
                                                <div class="col-md-6 payslip-details-info-right">
                                                    <div class="wrapper">
                                                        <div class="first">Leaving Date</div>
                                                        <div class="second">{{ details.leaving_date }}</div>
                                                    </div>
                                                </div>
                                            </template>
                                        </template>
                                    </div>
                                </div> 
                            </div>
                        </div>
                
                    </div>
                </div>

            </b-overlay>
        </b-modal>
    </div>
</template>
<script>
export default{
        mounted() {
            //if(this.employeedata.last_working_day == '0000-00-00')
                //this.fdata.last_working_day = '';
            
            this.showoverlay = false;
        },
        components: {
        },
        data(){            
            const now = new Date()
            const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
            const minDate = new Date(today);
            return {
                     
    
                showoverlay : true,
                gf_start_date : '',
                errormsg:[],
                checkbox:1, 
                show_loader_3:true,    
                application_loading : false,
                employeesearch:{name:'',status:1},
                users : [], 
                em_tmp_custom_list:[],
                chosen_emp_id: 0,
                curr_emp_name: '',
                gf_approve_date: '',
                curr_update_id:'',
                curr_approve_date:'',
                curr_update_employee:'',
                details:[],
                /**Child Component property data */

                is_n_gf:1,
                em_reg_appended_column:[                 
                    // { value: "gf_start", text: "GF Start Date",type: "date"},
                    // { value: "gf_confirmation_date", text: "GF Confirmation Date",type: "date"},
                    // { value: "gf_end", text: "GF End Date",type: "date"},
                    // { value: "service_period", text: "Service Period",type: "text"},
                    { value: "payable_amount", text: "Payable Amount",type: "amount"},
                    { value: "status", text: "Status",type: "text"},
               
                ],       
                em_reg_tmp_custom_list:[],
                em_reg_company_options:[],
                em_reg_custom_list:[],
                em_reg_list_key:0, /* As this list have actions then is_action will be 1. Otherwise it will be 0 */
                em_reg_list_key:0,
                em_reg_primary_key:'id',
                em_reg_default_column:['name','employee_code', 'date_of_joining'], /* Default Column List */
                em_selected: [],
                selected: [],


                /***Child Component property data */

                gf_profile_data:[],
                min_date:minDate,
                curr_date:minDate,

                
            }

            
        },
        methods:{
            
            getMinDate(date)
            {
                return date;
            },
            gfGetRegisteredEmployees: function()
            {
                this.min_date = this.curr_date;
                let currentObj = this;
                currentObj.show_loader = true;
                axios.get(this.$api_url+'/gf/employee/reglist' , {
    
                }).then(function(response){

                    
                this.em_reg_custom_list = [];



                if (typeof response.data.employee_data !== 'undefined')
                {
                    /* Assingning the list */ 
                    this.em_reg_tmp_custom_list = response.data.employee_data;
                    /* Assingning the list */ 
                    this.em_tmp_custom_list = Object.keys(response.data.employee_data).map((key) => (response.data.employee_data[key]));
                }
                if (typeof response.data.options !== 'undefined')
                {
                    /* Assingning the Options */ 
                    this.em_reg_company_options = Object.keys(response.data.options).map((key) => (response.data.options[key]));
                }
                
                // console.log(this.em_reg_tmp_custom_list);
                // console.log(this.em_reg_company_options);

                /* Now if we have actions in this grid then we have to create an additional key in each row and assing the actions for each row accordingly */
                
                if(this.em_tmp_custom_list.length > 0 )
                {
                    this.em_tmp_custom_list.forEach(element => {
                            if(element.employee_id > 0)
                            {
                                
                                element.gf_total = this.formatMoney(element.gf_total);
                                let dop = []; 
                                let last_payslip =  element.last_payslip;


                                // if(element.gf_end != '0000-00-00' && last_payslip != null && element.status != 'Settled')
                                // {
                                    
                                //     const last_payslip_array = last_payslip.split('-');
                                //     var last_payslip_date = new Date(last_payslip_array[0],last_payslip_array[1],0);


                                //     let gf_end =  element.gf_end;
                                //     const gf_end_array = gf_end.split('-');
                                //     var gf_end_date = new Date(gf_end_array[0],gf_end_array[1]-1,gf_end_array[2]);
                                //     var gf_end_month = gf_end_date.getMonth() + 1;
                                //     var gf_end_year = gf_end_date.getFullYear();
                                    
                                //     // if (cur_month >= gf_end_month && cur_year == gf_end_year) {
                                    
                                        
                                //     if(last_payslip_date.getTime() >= gf_end_date.getTime())
                                //     {
                                //             /*  If DropDown type one is First Choice */
                                //         element.status = 'Unsettled';

                                //     }


                                // }
                                // if(element.gf_end == '0000-00-00')
                                // {
                                //     element.gf_end ='';
                                // }
                                // if(element.locked == 1)
                                // {
                                //     dop = dop.concat([{ label: 'Locked' , value: 0 }]);
                                //     dop = dop.concat([{ label: 'Quick View' , value: 3 }]);
                                // }
                                

                                // /* If DropDown type one is Second Choice */
                                // if(element.status == 'Active' && element.locked != 1)
                                // {
                                //     dop = dop.concat([{ label: 'Edit' , value: 1 }]);
                                //     dop = dop.concat([{ label: 'Delete' , value: 2 }]);
                                //     dop = dop.concat([{ label: 'Quick View' , value: 3 }]);
                                // }
                                // else
                                // {
                                //     dop = dop.concat([]);
                                // }
                                dop = dop.concat([{ label: 'Quick View' , value: 3 }]);
                                
                                /* Action for all column **/
                            

                                element.actions = dop;

                            }
                        });

                        //console.log(this.em_tmp_custom_list);
                        this.em_reg_custom_list = this.em_tmp_custom_list;
                        //console.log(this.em_reg_custom_list); 
                        
                        if(this.em_reg_custom_list.length > 0)
                        {
                        
                            
                        }
                }
                else
                {
                    this.blankmsg = "No employee found as leaver";
                }
            
            
            this.em_reg_list_key = this.list_key + 1;
            currentObj.show_loader = false;
            
            }.bind(this)).catch(function (error){
                currentObj.show_loader = false;
                console.log(error);
                currentObj.serverError(error);
                
                });
            },
            
            updateEmployeeGF: function()
            {
                if(this.curr_update_id && this.curr_update_employee && this.curr_approve_date){
                
                var curr_obj = this;
            
                    let formData = new FormData();
                    formData.append('id', this.curr_update_id);
                    formData.append('gf_start_date', this.curr_approve_date);


                    axios.post(this.$api_url + '/gf/update-employee-gf', formData)
                    .then(function (response) 
                    {
                        if(response.data.success)
                        {
                            curr_obj.$bvToast.toast("Successfully updated", {title: 'Success',variant: 'success',solid: true});
                            curr_obj.curr_update_id =0;
                            curr_obj.curr_update_employee =0;
                            curr_obj.curr_approve_date =0;
                            curr_obj.gfGetRegisteredEmployees();

                        }
                        else if(response.data.errors)
                        {
                            curr_obj.$bvToast.toast(response.data.errors, {title: 'Error!',variant: 'danger',solid: true, toaster: "toaster: b-toaster-top-right"});  
                        }
                        curr_obj.$bvModal.hide('bv-modal-update-gf');
                    }.bind(this))
                    .catch(function (error) 
                    {
                        curr_obj.errormsg = error.response.data.errors;
                        console.log(error);
                    }); 
                }
                else
                {
                    this.$bvToast.toast("Please choose employee and enter GF start date", {title: 'Error!',variant: 'danger',solid: true, toaster: "toaster: b-toaster-top-right"});
                }
            },
            exportUpdateGFSelected: function()
            {
                if(this.em_selected == '')
                this.$bvToast.toast("No employee selected", {title: 'Error!',variant: 'danger',solid: true, toaster: "toaster: b-toaster-top-right"});
                else
                {
                    this.exportUpdatetGF('selected');
                }

            },
            
            exportUpdatetGF: function(sltd='')
            {
                
                this.$bvToast.toast('It might take a while', {
                                        title: `Info`,
                                        variant: 'info',
                                        solid: true
                                    });
                //console.log(this.em_selected);

                this.showoverlay = true;
                let formData = new FormData();
                if(sltd.length>0 && this.em_selected)
                formData.append('ids', this.em_selected);
                
                axios.post(this.$api_url+'/gf/export/update', formData)
                .then(function (response) 
                {                 
                    this.showoverlay = false;                                                   
                    //window.open(response.data);
                    var fileURL = response.data;
                    this.download_file(fileURL);
                    
                }.bind(this))
                .catch(function (error) 
                {
                    console.log(error);
                });

            },


            download_file(fileURL) 
            {
                if(!this.checkNet()) return false;
                
                var fileName = fileURL.substring(fileURL.lastIndexOf('/')+1);
                if (!window.ActiveXObject) {
                    var save = document.createElement('a');
                    save.href = fileURL;
                    save.target = '_blank';
                    //var filename = fileURL.substring(fileURL.lastIndexOf('/')+1);
                    save.download = fileName || filename;
                    if ( navigator.userAgent.toLowerCase().match(/(ipad|iphone|safari)/) && navigator.userAgent.search("Chrome") < 0) {
                            document.location = save.href;
                        }else{
                            var evt = new MouseEvent('click', {
                                'view': window,
                                'bubbles': true,
                                'cancelable': false
                            });
                            save.dispatchEvent(evt);
                            (window.URL || window.webkitURL).revokeObjectURL(save.href);
                        }    
                }
                else if ( !! window.ActiveXObject && document.execCommand)     {
                    var _window = window.open(fileURL, '_blank');
                    _window.document.close();
                    _window.document.execCommand('SaveAs', true, fileName || fileURL)
                    _window.close();
                }
            },
            getGfEmployeeData:function(employee_id)
            {
                let formData = new FormData();
                formData.append('employee_id', employee_id);
                axios.post(this.$api_url + '/gf/get-employee-data', formData)
                .then(function (response) 
                {     
                    this.gf_profile_data = response.data.data;
                }.bind(this));
            },

            deleteGF:function(gf_id)
            {
                var curr_obj = this;
                let formData = new FormData();
                formData.append('gf_id', gf_id); 
                axios.post(this.$api_url+'/gf/delete', formData) 
                    .then(function (response) 
                    {    
                        curr_obj.$bvToast.toast("Successfully updated", {title: 'Success',variant: 'success',solid: true});
                        curr_obj.$bvModal.hide('delete-modal'); 
                        curr_obj.curr_update_id =0;
                        curr_obj.gfGetRegisteredEmployees();
                        
                        
                    }.bind(this))
                    .catch(function (error) 
                    {
                        curr_obj.$bvToast.toast(error, {title: 'Error',variant: 'danger',solid: true});
                        console.log(error);
                    });

            },

            gfDetailsNew: function(employee_id)
            { 
                if(employee_id>0){
                let currentObj = this;
                
                let formData = new FormData();
                formData.append('employee_id', employee_id); 

                
                this.report_data = [];
                this.details = [];
                this.employee_info = [];
                
                axios.post(this.$api_url + '/gf/get-employee-data', formData)
                                    .then(function (response) 
                                    {
                            
                                        currentObj.details = response.data.data;
                                        
                                    }.bind(this))
                                    .catch(function (error) 
                                    {
                                        console.log(error);
                                    }); 

                    }

                    this.$bvModal.show('bv-modal-gf-details');

            },

            reg_edit:function(data)
            {
                //console.log(data);

                this.curr_update_id = 0;
                this.curr_approve_date= 0;
                this.curr_update_employee= 0;

                if(data.selected.length > 0)
                {
                    this.em_selected = data.selected;
                }
                else
                {
                    this.em_selected = [];

                }

                if(data.id && data.action_id==1)
                {
                    var item  = this.em_reg_custom_list.find(item => item.id === data.id); 
                    this.curr_update_id =item.id;
                    this.curr_approve_date=item.gf_confirmation_date;
                    this.curr_update_employee=item.name;
                    this.min_date = item.joining_date;
                    this.$bvModal.show('bv-modal-update-gf');
                   
                }

                if(data.id && data.action_id==2)
                {
                    var item  = this.em_reg_custom_list.find(item => item.id === data.id); 
                    
                    this.curr_update_id =item.id;
                    this.curr_approve_date=item.gf_start;
                    this.curr_update_employee=item.name;
                    this.$bvModal.show('delete-modal');
                    
                }
                if(data.id && data.action_id==3)
                {
                    var item  = this.em_reg_custom_list.find(item => item.id === data.id); 
                    this.gfDetailsNew(item.employee_id);
                   
                }

            },
            
        },
        created: function(){
            if(!this.checkNet()) return false;
        
            this.$validator.reset();
            this.gfGetRegisteredEmployees();

        } 
    }
</script> 